<template>
<!--hero section start-->
  <v-app>
    <v-container fluid fill-height class="pa-0 gray-bg">
      <v-row no-gutters class="align-items-center justify-content-center fill-height" align="center">
        <v-col class="col-12 col-md-6 col-lg-8  d-none d-md-block fill-height" >
          <!-- Image -->
          <div class="bg-cover background-img fill-height" style="background-image: url(/assets/img/hero-bg-1.jpg);">
            <div class="login-signup-content">
              <div class="col-md-12 col-lg-7">
                  <h2 class="text-white mb-2">Hai dimenticato la password ? </h2>
                  <p class="lead">Non preoccuparti, puoi resettarla!</p>
              </div>
            </div>
          </div>
        </v-col>
        <v-col class="col-12 col-md-6 col-lg-4">
          <div class="login-signup-wrap px-4 px-lg-5 my-5">
            <!-- Heading -->
            <div v-if="notConfirmed">
              <h1 class="text-center mb-1">
                Abbiamo inviato una nuova password temporanea al tuo indirizzo email
              </h1>
              <p class="text-center mb-5">
                <router-link to="/">Vai alla pagina di login</router-link>
              </p>
            </div>
            <div v-else-if="codeSent">
              <h1 class="text-center mb-1">
                Inserisci il codice
              </h1>
               <v-text-field
                v-model="code"
                :rules="notEmpty"
                solo
                color="#e94e1b"
                >
                </v-text-field>
                <label class="py-4 mb-4">
                  <v-btn color="#e94e1b" text large block  @click="startTimer(),sendMail() " :disabled="timeLeft>0">Richiedi nuovamente il codice <span v-if="timeLeft>0"> ( {{formattedTimeLeft}} )</span></v-btn>
                </label>
                <v-btn large block class="submit-btn" :disabled="code.length==0" :loading="loading" @click="codeSent=false,changePasswd=true">
                  Aggiorna
                </v-btn>
            </div>
            <div v-else-if="changePasswd">
              <h1 class="text-center mb-1">
                  Cambia la password
              </h1>
              <p class="text-center mb-5">
                  Inserisci la nuova password
              </p>

              <!--login form-->
              <v-form ref="passwd_form" v-model="valid">
                <label class="pb-1">
                  Nuova Password
                </label>
                <v-text-field
                  v-model="password"
                  placeholder="Inserisci la nuova password"
                  :rules="notEmptyPasswd"
                  solo
                  prepend-inner-icon="lock"
                  color="#e94e1b"
                  type="password"
                >
                </v-text-field>

                <label class="pb-1 d-flex justify-space-between">
                  Conferma Password
                </label>
                <v-text-field
                  v-model="confirmPasswd"
                  placeholder="Reinserisci la password"
                  :rules="notEmptyConfirmPasswd"
                  solo
                  prepend-inner-icon="lock"
                  color="#e94e1b"
                  type="password"
                >
                </v-text-field>
                <!-- Submit -->
                <v-btn large block class="submit-btn" :loading="loading" @click="resetPassword">
                    Conferma
                </v-btn>
              </v-form>
            </div>
            <div v-else-if="resetSuccess">
               <h1 class="text-center mb-1">
                  Password resettata correttamente
              </h1>
              <p class="text-center mb-5">
               <router-link to="/">Vai alla pagina di login</router-link>
              </p>
            </div>
            <div v-else>
              <h1 class="text-center mb-1">
                  Reset Password
              </h1>
              <p class="text-center mb-5">
                Inserisci la tua email per riceve il codice per il reset della tua password.
              </p>
              <!--login form-->
              <v-form ref="form" v-model="valid">
                <label class="pb-1">
                  Email
                </label>
                <v-text-field
                  v-model="email"
                  placeholder="nome@dominio.com"
                  :rules="notEmptyEmail"
                  solo
                  prepend-inner-icon="email"
                  color="#e94e1b"
                >
                </v-text-field>

                <v-btn large block class="submit-btn" :loading="loading" @click="submit">
                    Aggiorna
                </v-btn>

                <!-- Link -->
                <p class="text-center mt-5">
                    <small class="text-muted text-center">
                        Non hai ancora un account? <router-link to="/signup/free">Registrati</router-link>.
                    </small>
                </p>
                <input hidden id="g-recaptcha-response" name="g-recaptcha-response" />
              </v-form>
            </div>
          </div>
        </v-col>
      </v-row> 
    </v-container>
     <v-snackbar
        v-model="error"
        timeout="2000"
        color="error"
      >{{snackText}}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="error = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>
<script>
  import { Auth } from 'aws-amplify'
  import axios from 'axios'
  export default({
    name:"Reset",
    data: function(){
      return{
        error:false,
        snackText:'',
        valid:'',
        email:'',
        password:'',
        loading:false,
        notEmptyEmail: [
          v => !!v || "Inserire  l'email",
          v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Indirizzo non valido.'           
        ],
        notEmptyPasswd: [
          v => !!v || "Inserire la password",
        ],
        notEmptyConfirmPasswd:[
          v => !!v || "Inserire nuovamente la password",
          v => v == this.password || "Le password non combaciano"
        ],
        codeSent:false,
        code:'',
        confirmPasswd:'',
        changePasswd:'',
        resetSuccess:false,
        disableResend:false,
        timer:300, //timer resend in seconds,
        timeLeft:300,
        timerInterval:null
      }
    },
    methods:{
      sendMail:function(){
         Auth.forgotPassword(this.email)
           //eslint-disable-next-line
          .then(response =>{
            this.codeSent=true
            this.loading=false
          })
          .catch(error =>{
            console.log(error)
            if(error.code == "NotAuthorizedException"){
              this.notConfirmed = true
              axios.post(localStorage.Endpoint+"/resetUser",{"username":this.email})
               //eslint-disable-next-line
              .then(response =>{  
                this.notConfirmed = true
              })
              .catch(error =>{
                this.snackText = error.code
                this.error=true
              })
            }
            else{
              if(error.code == "LimitExceededException")
                this.snackText = "Hai superato il limite di tentativi previsto, riprova più tardi"
              else
                this.snackText = "Email errata o non registrata"
              this.error=true
            }
            this.loading=false
          })
      },
      submit:function(){
        if(this.$refs.form.validate()){
          this.loading=true
           //eslint-disable-next-line
          this.sendMail()
        }
      },

      resetPassword: function(){
        if(this.$refs.passwd_form.validate()){
          this.loading=true
          Auth.forgotPasswordSubmit(this.email,this.code,this.password)
          //eslint-disable-next-line
          .then(response=>{
            this.changePasswd=false
            this.resetSuccess=true,
            this.loading=false
          })
          //eslint-disable-next-line
          .catch(error=>{
            if(error.code == "LimitExceededException")
              this.snackText = "Hai superato il limite di tentativi previsto, riprova più tardi"
            this.snackText="Impossibile reimpostare la password. Riprova più tardi",
            this.error=true,
            this.loading=false
          })
        }
      },

      startTimer: function(){
        this.timeLeft=this.timer

        this.timerInterval = setInterval(() => {
          
          this.timeLeft -= 1
          if(this.timeLeft == 0)
            clearInterval(this.timerInterval)
        }, 1000);
      }
    },
    computed:{
      formattedTimeLeft: function(){

        let minutes = Math.floor(this.timeLeft / 60)    
        let seconds = this.timeLeft % 60      
  
        if (seconds < 10) {
          seconds = `0${seconds}`
        }     

        return `${minutes}:${seconds}`
      }
    }
  })
</script>
<style>
.background-img{
    position: relative;
    width: 100%;
    display: block;
    background-size: cover;
    background-position: center;
}
.background-img:before{
    position: absolute;
    content: '';
    background-color: rgba(233, 78, 27, 0.62);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.gray-bg{
  background-color:#f4f7fa
}

/*login css*/
.login-signup-content{
    height: 100%;
    width: 100%;
    z-index: 1;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    color:#fff;
    position: absolute;
    font-family: 'Montserrat', sans-serif;
    line-height: 1.75
}

.login-signup-content h2{
  font-size:2.5em;
  line-height: 1.21;
}
.login-signup-content .lead{
  font-size:1.25em
}
label{
  font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 88%;
}

.v-input__slot{
  border-color: #e94e1b !important;
  border-style: solid;
  border-width: 0 0 0 2px;
}

.submit-btn{
  background-color: #e94e1b !important;
  color: #fff !important;
}

</style>